'use client'

import { useEffect } from 'react'
import { reportClientError } from '@/components/ErrorReporter'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportClientError({ name: error.name, message: error.message, stack: error.stack })
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Что-то пошло не так</h1>
        <p className="text-sm text-gray-500 mb-6">
          Мы уже получили уведомление и разбираемся. Попробуйте ещё раз.
        </p>
        <button
          onClick={reset}
          className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-sm font-semibold"
        >
          Попробовать снова
        </button>
      </div>
    </div>
  )
}
